import LocationBox from "./LocationBox";

export default LocationBox;
